import { render, staticRenderFns } from "./userCourseMsg.vue?vue&type=template&id=56a7c8b5&scoped=true"
import script from "./userCourseMsg.vue?vue&type=script&lang=js"
export * from "./userCourseMsg.vue?vue&type=script&lang=js"
import style0 from "./userCourseMsg.vue?vue&type=style&index=0&id=56a7c8b5&prod&lang=scss"
import style1 from "./userCourseMsg.vue?vue&type=style&index=1&id=56a7c8b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a7c8b5",
  null
  
)

export default component.exports